import { render, staticRenderFns } from "./hotgpt.vue?vue&type=template&id=fb6678ac&scoped=true"
import script from "./hotgpt.vue?vue&type=script&lang=js"
export * from "./hotgpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6678ac",
  null
  
)

export default component.exports